import { render, staticRenderFns } from "./PermPlacementDetails.vue?vue&type=template&id=561c2dfb&scoped=true&"
import script from "./PermPlacementDetails.vue?vue&type=script&lang=js&"
export * from "./PermPlacementDetails.vue?vue&type=script&lang=js&"
import style0 from "./PermPlacementDetails.vue?vue&type=style&index=0&id=561c2dfb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561c2dfb",
  null
  
)

export default component.exports